// extracted by mini-css-extract-plugin
export default {"root":"root--a8ea0bb","bannerContainer":"bannerContainer--f606cb8","banner":"banner--d4f0cf5"};